import React, { Component } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Chip,
  Stack,
} from "@mui/material";
import roupa from "../../../images/roupa.jpeg";
import eletrnico from "../../../images/eletronico.jpg";
import casa from "../../../images/casa.jpg";
import beleza from "../../../images/beleza.jpg";
import food from "../../../images/food.jpg";
import { Link } from "react-router-dom";

// Ícones MUI para cada segmento
import CheckroomIcon from "@mui/icons-material/Checkroom";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import HomeIcon from "@mui/icons-material/Home";
import SpaIcon from "@mui/icons-material/Spa";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import assistencia from "../../../images/assistencia.jpeg";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

class SegmentosComercio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      segmentos: [
        {
          id: "moda",
          titulo: "Moda e Vestuário",
          subtitulo: "Roupas, Calçados e Acessórios",
          descricao: "Organize grades de tamanho e cores, exiba fotos profissionais e venda direto pelo seu link próprio.",
          icone: <CheckroomIcon sx={{ color: "#7C3AED" }} />,
          tag: "Moda & Estilo",
          imagemPlaceholder: roupa,
        },
        {
          id: "eletronicos",
          titulo: "Eletrônicos e Informática",
          subtitulo: "Smartphones, Acessórios e Gadgets",
          descricao: "Controle números de série, especificação técnica de produtos e mantenha o estoque físico e virtual alinhados.",
          icone: <PhoneIphoneIcon sx={{ color: "#7C3AED" }} />,
          tag: "Tecnologia",
          imagemPlaceholder: eletrnico,
        },
        {
          id: "casa",
          titulo: "Casa, Decoração e Utilidades",
          subtitulo: "Bazar, Presentes e Ferramentas",
          descricao: "Agilize o atendimento no balcão da loja física (PDV) e permita que clientes comprem consultando o catálogo online.",
          icone: <HomeIcon sx={{ color: "#7C3AED" }} />,
          tag: "Variedades",
          imagemPlaceholder: casa,
        },
        {
          id: "cosmeticos",
          titulo: "Cosméticos e Perfumaria",
          subtitulo: "Beleza, Cuidados e Maquiagem",
          descricao: "Facilite a rotina de pedidos rápidos por mensagens e organize kits promocionais com poucos cliques.",
          icone: <SpaIcon sx={{ color: "#7C3AED" }} />,
          tag: "Beleza",
          imagemPlaceholder: beleza,
        },
        {
          id: "alimentacao",
          titulo: "Alimentação e Delivery",
          subtitulo: "Restaurantes, Lanchonetes e Confeitarias",
          descricao: "Cardápio digital interativo, controle de mesas, comandas e integração direta com impressoras térmicas.",
          icone: <RestaurantMenuIcon sx={{ color: "#7C3AED" }} />,
          tag: "Food Service",
          imagemPlaceholder: food,
        },
        {
          id: "assitencia-tecnica",
          titulo: "Assistência Técnica e Serviços",
          subtitulo: "Manutenção, Reparos e Consultoria",
          descricao: "Gerencie ordens de serviço, acompanhe o status dos reparos e mantenha um histórico detalhado para cada cliente.",
          icone: <HomeIcon sx={{ color: "#7C3AED" }} />,
          tag: "Serviços",
          imagemPlaceholder: assistencia,
        }
      ],
    };
  }

  render() {
    return (
      <Box
        component="section"
        id="segmentos"
        sx={{
          bgcolor: "#F9F8FF",
          py: { xs: 6, sm: 10 },
          borderTop: "1px solid #D8D4FE",
          borderBottom: "1px solid #D8D4FE",
        }}
      >
        <Container maxWidth="xl">
          {/* Cabeçalho da Seção */}
          <Box sx={{ textAlign: "center", maxWidth: "700px", mx: "auto", mb: 8 }}>
            <Chip
              label="SOLUÇÃO VERSÁTIL PARA O SEU NEGÓCIO"
              sx={{
                bgcolor: "#F2ECFF",
                color: "#7C3AED",
                fontWeight: 700,
                fontSize: "0.75rem",
                border: "1px solid rgba(124, 58, 237, 0.3)",
                mb: 2,
              }}
            />
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontWeight: 800,
                color: "#1E1B4B",
                fontSize: { xs: "2rem", sm: "2.5rem" },
                mb: 2,
              }}
            >
              Feito sob medida para o seu segmento de comércio
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "#464467", fontSize: { xs: "1rem", sm: "1.1rem" } }}
            >
              Seja qual for o tamanho ou o nicho da sua empresa, o <strong>FazPedido</strong> organiza suas vendas, seu estoque e seu caixa em um só lugar.
            </Typography>
          </Box>

          {/* Grade de Segmentos */}
          <Grid container spacing={4}>
            {this.state.segmentos.map((item) => (
              <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={item.id}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "20px",
                    border: "1px solid #D8D4FE",
                    bgcolor: "background.paper",
                    transition: "all 0.3s ease-in-out",
                    overflow: "hidden",

                  }}
                >
                  {/* Imagem Ilustrativa do Segmento */}
                  <CardMedia
                    component="img"
                    height="180"
                    image={item.imagemPlaceholder}
                    alt={item.titulo}
                    sx={{ objectFit: "cover" }}
                  />

                  <CardContent sx={{ p: 4, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                    {/* Ícone e Tag */}
                    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                      <Box
                        sx={{
                          p: 1,
                          bgcolor: "#F2ECFF",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {item.icone}
                      </Box>
                      <Chip
                        label={item.tag}
                        size="small"
                        sx={{
                          bgcolor: "#F2ECFF",
                          color: "#7C3AED",
                          fontWeight: 600,
                          fontSize: "0.7rem",
                        }}
                      />
                    </Stack>

                    {/* Títulos */}
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{ fontWeight: 700, color: "#1E1B4B", fontSize: "1.25rem", mb: 0.5 }}
                    >
                      {item.titulo}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "#7C3AED", fontWeight: 600, mb: 2, fontSize: "0.85rem" }}
                    >
                      {item.subtitulo}
                    </Typography>

                    {/* Descrição */}
                    <Typography
                      variant="body2"
                      sx={{ color: "#464467", lineHeight: 1.6, mb: 3, flexGrow: 1 }}
                    >
                      {item.descricao}
                    </Typography>

                    {/* Ação Interna do card */}
                    <Button
                      component={Link}
                      to="/auth/register"
                      endIcon={<ArrowForwardIcon />}
                      sx={{
                        color: "#7C3AED",
                        fontWeight: 700,
                        textTransform: "none",
                        p: 0,
                        justifyContent: "flex-start",
                        "&:hover": {
                          bgcolor: "transparent",
                          color: "#6D28D9",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      Criar catálogo para {item.tag}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    );
  }
}

export default SegmentosComercio;